import { useId, type ReactNode } from "react";
import { cn } from "@/shared/lib/utils";
import { Textarea, type TextareaProps } from "@/shared/components/ui/Textarea";
import { Label } from "@/shared/components/ui/Label";

/**
 * Multi-line analogue of FormField (design.md §10). The mx-4 label/error
 * alignment matches Textarea's px-4 inner padding — see FormField for the
 * rationale.
 */
export interface TextareaFormFieldProps extends TextareaProps {
  label: string;
  hint?: ReactNode;
  error?: ReactNode;
}

export function TextareaFormField({
  label,
  hint,
  error,
  id,
  className,
  ...textareaProps
}: TextareaFormFieldProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <Label htmlFor={inputId} className="mx-4">
        {label}
      </Label>
      <Textarea id={inputId} aria-invalid={error ? true : undefined} {...textareaProps} />
      {error ? (
        <p className="mx-4 type-body-sm text-danger-strong">{error}</p>
      ) : hint ? (
        <p className="mx-4 type-body-sm text-text-muted">{hint}</p>
      ) : null}
    </div>
  );
}
